import { getUrl, getSSIUrl } from "@xo-union/dist-url";
const DIST_NAME = 'tk-pagelet-footer-nav';
export const getFooterAssetUrl = (tag, path) => getUrl({
  params: {
    name: DIST_NAME,
    tag,
    path
  }
});
export const getFooterSSIUrl = (tag, path) => getSSIUrl({
  params: {
    name: DIST_NAME,
    tag,
    path
  }
});
export const KNOT_HOST_MAP = {
  qa: 'https://qa-beta.theknot.com',
  production: 'https://www.theknot.com'
};